import firebase from '../../firebase/firebase';
import {
    SET_DOCUMENT, LOAD_DOCUMENT, LOAD_DOCUMENT_SUCCESS, LOAD_DOCUMENT_FAILURE,
    LOAD_DOCUMENT_IMAGE, LOAD_DOCUMENT_IMAGE_SUCCESS, LOAD_DOCUMENT_IMAGE_FAILURE,
    SET_NEXT_INPUT_TYPE, ADD_INPUT, DELETE_INPUT,
    MOVE_INPUT_ON_DOCUMENT, UPDATE_INPUT_ON_DOCUMENT,
    GET_ALL_STATIC_DOCUMENTS, RECEIVED_ALL_STATIC_DOCUMENTS, GET_USERS_DOCUMENTS, RECEIVED_ALL_USER_DOCUMENTS,
    SAVE_CURRENT_DOCUMENT, SAVE_CURRENT_DOCUMENT_SUCCESS, FINALIZE_DOCUMENT, FINALIZE_DOCUMENT_SUCCESS
} from '../../_actions/types';

export function getAllStaticDocuments() {
    return (dispatch) => {
        dispatch({ type: GET_ALL_STATIC_DOCUMENTS });

        firebase.database()
            .ref('static-documents/state/Tennessee/documents')
            .once('value')
            .then(snapshot => {
                const staticDocuments = snapshot.val();
                dispatch(receivedAllStaticDocuments(staticDocuments));
            });
    };
}

function receivedAllStaticDocuments(documents) {
    return {
        type: RECEIVED_ALL_STATIC_DOCUMENTS,
        documents
    };
}

export function getUserDocuments() {
    return (dispatch, getState) => {
        dispatch({ type: GET_USERS_DOCUMENTS });

        const state = getState();

        firebase.database()
            .ref(`users/${state.auth.user.uid}/documents`)
            .once('value')
            .then(snapshot => {
                const userDocuments = snapshot.val();

                if (userDocuments) {
                    dispatch(receivedAllUserDocuments(userDocuments));
                }
            });
    };
}

function receivedAllUserDocuments(documents) {
    return {
        type: RECEIVED_ALL_USER_DOCUMENTS,
        documents
    };
}

export function setDocument(name) {
    return {
        type: SET_DOCUMENT,
        name
    };
}

export function loadNewDocument(name) {
    return (dispatch) => {
        dispatch(startLoadingDocument(name));

        firebase.database()
            .ref(`static-documents/state/Tennessee/documents/${name}`)
            .once('value')
            .then(snapshot => {
                const documentData = snapshot.val();
                dispatch(loadDocumentSuccess());
                dispatch(loadDocumentImage(documentData.image_url));
            })
            .catch(() => {
                dispatch(loadDocumentFailure("Document data failed to load"));
            });
    }
}

export function loadExistingDocument(name) {
    return (dispatch) => {
        dispatch(startLoadingDocument(name));

        firebase.database()
            .ref(`documents/${name}`)
            .once('value')
            .then(snapshot => {
                const documentData = snapshot.val();
                dispatch(loadDocumentSuccess(documentData.formData));
                dispatch(loadDocumentImage(documentData.imageName));
            })
            .catch(() => {
                dispatch(loadDocumentFailure("Document data failed to load"));
            });
    }
}


function startLoadingDocument(name) {
    return {
        type: LOAD_DOCUMENT,
        name
    };
}

function loadDocumentSuccess(formData = []) {
    return {
        type: LOAD_DOCUMENT_SUCCESS,
        formData
    };
}

function loadDocumentFailure(errorMessage) {
    return {
        type: LOAD_DOCUMENT_FAILURE,
        errorMessage
    };
}

function loadDocumentImage(imageName) {
    return (dispatch) => {
        dispatch(startLoadingDocumentImage(imageName));

        firebase.storage()
            .ref(imageName)
            .getDownloadURL()
            .then(imageUrl => dispatch(loadDocumentImageSuccess(imageUrl)))
            .catch(() => {
                dispatch(loadDocumentImageFailure("Could not load the document image."));
            });
    };
}

function startLoadingDocumentImage(imageName) {
    return {
        type: LOAD_DOCUMENT_IMAGE,
        imageName
    };
}

function loadDocumentImageSuccess(imageUrl) {
    return {
        type: LOAD_DOCUMENT_IMAGE_SUCCESS,
        imageUrl
    };
}

function loadDocumentImageFailure(errorMessage) {
    return {
        type: LOAD_DOCUMENT_IMAGE_FAILURE,
        errorMessage
    };
}

export function setNextInputType(docType) {
    return {
        type: SET_NEXT_INPUT_TYPE,
        docType
    };
}

export function addInput(top, left) {
    return {
        type: ADD_INPUT,
        top,
        left
    };
}

export function deleteInput(id) {
    return {
        type: DELETE_INPUT,
        id
    };
}

export function moveInput(id, top, left) {
    return {
        type: MOVE_INPUT_ON_DOCUMENT,
        id,
        top,
        left
    };
}

export function updateInput(id, value) {
    return {
        type: UPDATE_INPUT_ON_DOCUMENT,
        id,
        value
    };
}

export function saveCurrentDocument(name) {
    return (dispatch, getState) => {
        dispatch({ type: SAVE_CURRENT_DOCUMENT, name });

        const state = getState();
        const documentId = firebase.database().ref('documents').push().key;

        const document = {
            name,
            staticDocumentName: state.editor.name,
            formData: state.editor.formData,
            imageName: state.editor.imageName
        };

        let writeLocations = {};
        writeLocations['users/' + state.auth.user.uid + '/documents/' + documentId] = { name };
        writeLocations['documents/' + documentId] = document;

        firebase.database().ref().update(writeLocations);

        dispatch({
            type: SAVE_CURRENT_DOCUMENT_SUCCESS,
            id: documentId,
            name
        });
    }
}

export function finalizeDocument() {
    return {
        type: FINALIZE_DOCUMENT,
    };
}

export function finishedFinalizingDocument() {
    return {
        type: FINALIZE_DOCUMENT_SUCCESS
    };
}



// WEBPACK FOOTER //
// ./src/components/document-editor/editor_actions.js